export var limitStrategy = function limitStrategy(limitChars) {
  return function (contentBlock, callback) {
    var text = contentBlock.getText();
    if (text.length > limitChars) {
      return callback(limitChars, text.length);
    }
  };
};